import { Formik, Field, Form, FieldArray, ErrorMessage } from "formik";
import * as Yup from "yup"


function ListingShema() {
  const times = [
    '6:00AM', '6:30AM', '7:00AM', '7:30AM', '8:00AM', '8:30AM',
    '9:00AM', '9:30AM', '10:00AM', '10:30AM', '11:00AM', '11:30AM',
    '12:00PM', '12:30PM', '1:00PM', '1:30PM', '2:00PM', '2:30PM',
    '3:00PM', '3:30PM', '4:00PM', '4:30PM', '5:00PM', '5:30PM',
    '6:00PM', '6:30PM', '7:00PM', '7:30PM', '8:00PM', '8:30PM', '9:00PM',
  ];


  return <Formik
    initialValues={{
      title: "",
      listing_type: "",
      address: "",
      city: "",
      state: "",
      apt_suite: "",
      zipcode: "",
      country: "",
      area: "",
      lattitude: "",
      longitude: "",
      type_of_space: "",
      dwelling: "",
      no_of_guest: "",
      no_of_bedroom: "",
      no_of_bed: "",
      no_of_bathroom: "",
      no_of_room: "",
      size: "",
      unit_of_measure: "",
      description: "",
      image: [],
      bedrooms: [],
      airport: [],
    }}
    validationSchema={Yup.object({
      title: Yup.string().required("title is required."),
      listing_type: Yup.string().required("Listing Type is required."),
      address: Yup.string().required("Address is required."),
      apt_suite: Yup.string(),
      city: Yup.string().required("city is required."),
      state: Yup.string().required("state is required."),
      country: Yup.string().required("country is required."),
      zipcode: Yup.string().required("zipcode is required."),
      area: Yup.string().required("area is required."),
      no_of_guest: Yup.string().required("no_of_guest is required."),
      no_of_bedroom: Yup.string().required("no_of_bedroom is required."),
      no_of_bed: Yup.string().required("no_of_bed is required."),
      no_of_bathroom: Yup.string().required("no_of_bathroom is required."),
      no_of_room: Yup.string().required("no_of_room is required."),
      unit_of_measure: Yup.string().required("unit_of_measure is required."),
      description: Yup.string().required("description is required."),
      size: Yup.string().required("size is required."),
      lattitude: Yup.string(),
      longitude: Yup.string(),
      image: Yup.array(Yup.mixed().required('Images is required')),
      type_of_space: Yup.string().required("type of space is required"),
      dwelling: Yup.string().required("Lodging is required"),
      bedroom: Yup.array(Yup.object({
        name: Yup.string().required("bedroom name is requied"),
        guest: Yup.string().required("guest is requied"),
        bed: Yup.string().required("bed is requied"),
        type: Yup.string().required("bed type is requied"),
      })),
      airport: Yup.array(Yup.object({
        identifer: Yup.string().required("identifer is required"),
        airport_name: Yup.string().required("airport_name is required"),
        airport_use: Yup.string().required("airport_use is required"),
        operation_hours: Yup.string().required("operation_hours is required"),
        lighting: Yup.string().required("lighting is required"),
        ctaf_unicom: Yup.string().required("ctaf_unicom is required"),
        fuel: Yup.array(Yup.string().required("fuel is required")),
        parking: Yup.string().required("parking is required"),
        orientation: Yup.string().required("orientation is required"),
        surface: Yup.array(Yup.string().required("surface is required")),
        condition: Yup.string().required("condition is required"),
        elevation: Yup.string().required("elevation is required"),
        pattern: Yup.string().required("pattern is required"),
        distance_from_runway: Yup.string().required("distance_from_runway is required"),
        air_nav: Yup.string().required("air_nav is required"),
        ground_transportation: Yup.string().required("ground_transportation is required"),
        additional_information: Yup.string().required("additional_information is required"),
      }))
    })}
    onSubmit={values => console.log(values, "values")}


  >

    {({ errors, values }) => {
      return (
        <Form >
          <div>
            <div className="col-md-12">
              <div className="custom_box">
                <label>Listing Type</label>
                <Field name="listing_type" as="select" className="custom-select">
                  <option disabled value="">All categories</option>
                  <option value="Short-Term Rental">Short-Term Rental</option>
                  <option value="Adventure">Adventure </option>
                </Field>
                <ErrorMessage name="listing_type" className="error" />
              </div>
            </div>
          </div>
          <div>
            <h1>Section location</h1>
            <Field name="address" />
            <ErrorMessage name="address" />
            <Field name="apt_suite" />
            <ErrorMessage name="apt_suite" />
            <Field name="city" />
            <ErrorMessage name="city" />
            <Field name="state" />
            <ErrorMessage name="state" />
            <Field name="country" />
            <ErrorMessage name="country" />
            <Field name="zipcode" />
            <ErrorMessage name="zipcode" />
            <Field name="area" />
            <ErrorMessage name="area" />
            <Field name="lattitude" />
            <ErrorMessage name="lattitude" />
            <Field name="longitude" />
            <ErrorMessage name="longitude" />
          </div>
          <div>
            <h1>Section media</h1>


            <Field name="image" type="file" />
            <ErrorMessage name="image" />
          </div>
          <div>
            <h1>Section Information </h1>
            <Field name="type_of_space" as="select">
              <option value="">Select Type of Space</option>
              <option value="Entire Place">Entire Place</option>
              <option value="Private Room">Private Room</option>
              <option value="Shared Room (Requires Admin Approval)">Shared Room (Requires Admin Approval)</option>
            </Field>
            <ErrorMessage name="type_of_space" as="select" />
            <Field name="dwelling" as="select" />
            <option disabled value="">All categories</option>
            <option value="Apt/Condo/Loft">Apartment</option>
            <option value="Bed &amp; Breakfast">
              Bed &amp; Breakfast
            </option>
            <option value="Cabin">Cabin</option>
            <option value="Campsite">Campsite</option>
            <option value="Farm">Farm</option>
            <option value="Hangar">Hangar</option>
            <option value="Hangar Home">Hangar Home</option>
            <option value="House">House</option>
            <option value="Mansion">Mansion</option>
            <option value="Novelty">Novelty</option>
            <option value="RV">RV</option>
            <option value="Tiny Home">Tiny Home</option>

            <ErrorMessage name="dwelling" />
            <Field name="title" />
            <ErrorMessage name="title" />
            <Field name="no_of_guest" />
            <ErrorMessage name="no_of_guest" />
            <Field name="no_of_bedroom" />
            <ErrorMessage name="no_of_bedroom" />
            <Field name="no_of_bed" />
            <ErrorMessage name="no_of_bed" />
            <Field name="no_of_bathroom" />
            <ErrorMessage name="no_of_bathroom" />
            <Field name="no_of_room" />
            <ErrorMessage name="no_of_room" />
            <Field name="size" />
            <ErrorMessage name="size" />
            <Field name="unit_of_measure" as="select" />
            <option value="ft²">ft²</option>
            <option value="m²">
              m²
            </option>
            <ErrorMessage name="unit_of_measure" />
            <Field name="description" as="textarea" />
            <ErrorMessage name="description" />
          </div>

          <div>
            <h1>section Bedrooms</h1>

            <FieldArray name="bedrooms">

              {({ insert, remove, push }) => {
                return values.bedrooms?.map((itm, idx) => {
                  return <div>
                    <Field name={`itm.${idx}.name`} />
                    <Field name={`itm.${idx}.guest`} />
                    <Field name={`itm.${idx}.bed`} />
                    <Field name={`itm.${idx}.type`} />
                    <button type="button" onClick={() => remove(idx)}>X</button>
                    <button type="button" onClick={() => push("")}>+</button>
                  </div>
                })
              }}
            </FieldArray>
          </div>
          <div>
            <h1>section Airport Information</h1>

            <FieldArray name="airport">

              {({ insert, remove, push }) => {
                return values.airport?.map((itm, idx) => {
                  return <div>
                    <Field name={`itm.${idx}.identifer`} />
                    <ErrorMessage name={`itm.${idx}.identifer`} />
                    <Field name={`itm.${idx}.airport_name`} />
                    <ErrorMessage name={`itm.${idx}.airport_name`} />
                    <Field name={`itm.${idx}.airport_use`} as="select" >
                      <option value="">Airport Use</option>
                      <option value="Public">Public</option>
                      <option value="Private">Private</option>
                      <option value="Private - permission required to land">Private - permission required to land</option>
                    </Field>
                    <ErrorMessage name={`itm.${idx}.airport_use`} />

                    <Field name={`itm.${idx}.operation_hours`} />
                    <ErrorMessage name={`itm.${idx}.operation_hours`} />
                    <Field name={`itm.${idx}.lighting`} as="select" >
                      <option disabled value="">select</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Field>
                    <ErrorMessage name={`itm.${idx}.lighting`} />
                    <Field name={`itm.${idx}.ctaf_unicom`} />
                    <ErrorMessage name={`itm.${idx}.ctaf_unicom`} />
                    <Field name={`itm.${idx}.fuel`} />
                    <ErrorMessage name={`itm.${idx}.fuel`} />
                    <Field name={`itm.${idx}.parking`} as="select" >
                      <option value="Hangar">Hangar</option>
                      <option value="Hangar and Tie-downs">Hangar and Tie-downs</option>
                      <option value="Tie-downs">Tie-downs</option>
                    </Field>
                    <ErrorMessage name={`itm.${idx}.parking`} />
                    <Field name={`itm.${idx}.orientation`} />
                    <ErrorMessage name={`itm.${idx}.orientation`} />
                    <Field name={`itm.${idx}.dimensions`} />
                    <ErrorMessage name={`itm.${idx}.dimensions`} />
                    <Field name={`itm.${idx}.surface`} />
                    <ErrorMessage name={`itm.${idx}.surface`} />
                    <Field name={`itm.${idx}.condition`} />
                    <ErrorMessage name={`itm.${idx}.condition`} />
                    <Field name={`itm.${idx}.elevation`} />
                    <ErrorMessage name={`itm.${idx}.elevation`} />
                    <Field name={`itm.${idx}.pattern`} as="select" >
                      <option value="left, left">left, left</option>
                      <option value="left, right">left, right</option>
                      <option value="right, left">right, left</option>
                      <option value="right, right">right, right</option>
                    </Field>
                    <ErrorMessage name={`itm.${idx}.pattern`} />
                    <Field name={`itm.${idx}.distance_from_runway`} as="select" >
                      <option value="">Select Distance</option>
                      <option value="0 miles">0 miles</option>
                      <option value="0 to 1 miles">0 to 1 miles</option>
                      <option value="1.1 to 3 miles">1.1 to 3 miles</option>
                      <option value="3.1 to 7 miles">3.1 to 7 miles</option>
                      <option value="7+ miles">7+ miles</option>
                    </Field>
                    <ErrorMessage name={`itm.${idx}.distance_from_runway`} />
                    <Field name={`itm.${idx}.air_nav`} />
                    <ErrorMessage name={`itm.${idx}.air_nav`} />
                    <Field name={`itm.${idx}.ground_transportation`} as="select">
                      <option value="We have a courtesy car waiting for you!">We have a courtesy car waiting for you!</option>
                      <option value="We have a car you can rent from us!">We have a car you can rent from us!</option>
                      <option value="Rent a car right in the airport! Their phone number is:">Rent a car right in the airport! Their phone number is:</option>
                      <option value="We will give you a ride to the nearest rental car agency!">We will give you a ride to the nearest rental car agency!</option>
                      <option value="We have a deal with the FBO so you can keep the car your whole stay!">We have a deal with the FBO so you can keep the car your whole stay!</option>
                      <option value="You don't need a car here!">You don't need a car here!</option>
                    </Field>
                    <ErrorMessage name={`itm.${idx}.ground_transportation`} />
                    <Field name={`itm.${idx}.additional_information`} />
                    <ErrorMessage name={`itm.${idx}.additional_information`} />
                    <button type="button" onClick={() => remove(idx)}>X</button>
                    <button type="button" onClick={() => push("")}>+</button>
                  </div>
                })
              }}
            </FieldArray>
          </div>
          <div>
            <h1>section Pricing</h1>
            <Field name="instant_booking" type="checkbox" />
            <ErrorMessage name="instant_booking" />
            <Field name="nightly" />
            <ErrorMessage name="nightly" />
            <Field name="apply_weekend_price" as="select" >
              <option disabled value={""}>
                None
              </option>
              <option value={"Friday and Saturday"}>

                Friday and Saturday
              </option>
              <option value={"Saturday and Sunday"}>
                Saturday and Sunday

              </option>
              <option value={"Friday, Saturday and Sunday"}>
                Friday, Saturday and Sunday

              </option>
            </Field>
            <ErrorMessage name="apply_weekend_price" />
            <Field name="weekend" />
            <ErrorMessage name="weekend" />
            <Field name="weekly_seven_plus" />
            <ErrorMessage name="weekly_seven_plus" />
            <Field name="weekly_thirty_plus" />
            <ErrorMessage name="weekly_thirty_plus" />
            <Field name="addi_guest" as="select">   <option value="Yes">
              Yes
            </option>
              <option value="No">
                No
              </option></Field>
            <ErrorMessage name="addi_guest" />
            <Field name="no_of_addi_guest" />
            <ErrorMessage name="no_of_addi_guest" />
            <Field name="addi_guest_price" />
            <ErrorMessage name="addi_guest_price" />
            <Field name="clean_fee" />
            <ErrorMessage name="clean_fee" />
            <Field name="clean_fee_daily" as="select">
              <option value={"Per stay"}>Per stay </option>
              <option value={"Daily"}>Daily</option>
            </Field>
            <ErrorMessage name="clean_fee_daily" />
            <Field name="city_fee" />
            <ErrorMessage name="city_fee" />
            <Field name="city_fee_daily" as="select">
              <option value={"Per stay"}>Per stay </option>
              <option value={"Daily"}>Daily</option>
            </Field>
            <ErrorMessage name="city_fee_daily" />
            <Field name="tax" />
            <ErrorMessage name="tax" />

            <FieldArray name="extraServicePrices">

              {({ insert, remove, push }) => {
                return values.extraServicePrices?.map((itm, idx) => {
                  return <div>
                    <Field name={`itm.${idx}.name`} />
                    <ErrorMessage name={`itm.${idx}.name`} />
                    <Field name={`itm.${idx}.price`} />
                    <ErrorMessage name={`itm.${idx}.price`} />
                    <Field name={`itm.${idx}.quantity`} />
                    <ErrorMessage name={`itm.${idx}.quantity`} />
                    <Field name={`itm.${idx}.type`} as="select">
                      <option disabled value="">Type</option>
                      <option value="Singel Fee">Single Fee</option>
                      <option value="Per Night">Per Night</option>
                      <option value="Per Guest">Per Guest</option>
                      <option value="Per Night Per Guest">Per Night Per Guest</option>
                    </Field>
                    <ErrorMessage name={`itm.${idx}.type`} />
                    <button type="button" onClick={() => remove(idx)}>X</button>
                    <button type="button" onClick={() => push("")}>+</button>
                  </div>
                })
              }}
            </FieldArray>
            <FieldArray name="customPeriods">

              {({ insert, remove, push }) => {
                return values.customPeriods?.map((itm, idx) => {
                  return <div>
                    <Field name={`itm.${idx}.start_date`} />
                    <ErrorMessage name={`itm.${idx}.start_date`} />
                    <Field name={`itm.${idx}.end_date`} />
                    <ErrorMessage name={`itm.${idx}.end_date`} />
                    <Field name={`itm.${idx}.custom_price`} />
                    <ErrorMessage name={`itm.${idx}.custom_price`} />
                    <Field name={`itm.${idx}.custom_weekly_price`} />
                    <ErrorMessage name={`itm.${idx}.custom_weekly_price`} />
                    <Field name={`itm.${idx}.custom_price_additional`} />
                    <ErrorMessage name={`itm.${idx}.custom_price_additional`} />


                    <button type="button" onClick={() => remove(idx)}>X</button>
                    <button type="button" onClick={() => push("")}>+</button>
                  </div>
                })
              }}
            </FieldArray>
          </div>
          <div>
            <h1>section features</h1>
            <FieldArray name="blocks">

              {({ insert, remove, push }) => {
                return values.blocks?.map((itm, idx) => {
                  return <div>
                    <Field name={`itm.${idx}.start_date`} us="select">
                      <option disabled value="">Type</option>
                      <option value="Singel Fee">Single Fee</option>
                      <option value="Per Night">Per Night</option>
                    </Field>
                    <ErrorMessage name={`itm.${idx}.start_date`} />
                    <Field name={`itm.${idx}.end_date`} />
                    <ErrorMessage name={`itm.${idx}.end_date`} />
                    <Field name={`itm.${idx}.custom_price`} />
                    <ErrorMessage name={`itm.${idx}.custom_price`} />
                    <Field name={`itm.${idx}.custom_weekly_price`} />
                    <ErrorMessage name={`itm.${idx}.custom_weekly_price`} />
                    <Field name={`itm.${idx}.custom_price_additional`} />
                    <ErrorMessage name={`itm.${idx}.custom_price_additional`} />


                    <button type="button" onClick={() => remove(idx)}>X</button>
                    <button type="button" onClick={() => push("")}>+</button>
                  </div>
                })
              }}
            </FieldArray>
          </div>
          <div>
            <h1>Terms & Rules</h1>
            <Field name="min_day_booking" />
            <ErrorMessage name="min_day_booking" />
            <Field name="max_day_booking" />
            <ErrorMessage name="max_day_booking" />
            <Field name="check_in_after" as="select" >
              <option>Select</option>
              {times.map((time, index) => (
                <option key={index} value={time}>{time}</option>
              ))}
            </Field>
            <ErrorMessage name="check_in_after" />
            <Field name="check_in_before" as="select" >
              <option>Select</option>
              {times.map((time, index) => (
                <option key={index} value={time}>{time}</option>
              ))}
            </Field>
            <ErrorMessage name="check_in_before" />

            <Field name="smoking_allowed" as="select">
              <option disabled value={""}>Select</option>
              <option>Yes</option>
              <option>No</option>
            </Field>
            <ErrorMessage name="smoking_allowed" />
            <Field name="min_day_booking" />
            <ErrorMessage name="min_day_booking" />
            <Field name="min_day_booking" />
            <ErrorMessage name="min_day_booking" />
          </div>
          <button type="submit">Submit</button>
        </Form>
      )
    }}
  </Formik >
}


export default ListingShema





